export default __webpack_public_path__ + "static/media/seeding-kerala.a69190bb.png";